import styled from 'styled-components';
import { StyledProductRenderProps } from './ProductRender.types';

export const StyledProductRender = styled.div<StyledProductRenderProps>`
  position: relative;
  overflow: hidden;
  text-align: center;
  width: 100%;

  .product-render__image-holder {
    position: relative;

    .product-render__image {
      width: 100%;
      height: auto;
      vertical-align: top;
    }
  }

  .product-render__image-no-hover {
    position: relative;
  }

  img {
    &.product-render__image-hover {
      display: ${(props) => (props.isHovering ? 'block' : 'none')};
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  ${(props) => props.customStyle}
`;
